// extracted by mini-css-extract-plugin
module.exports = {"container":"_025a50318d--container--3cwNw","suffix":"_025a50318d--suffix--1b0vw"};